<template>
    <div class="TechStack">
      <img src="../assets/TechStack.png" height="80%">
    </div>
</template>

<script>
export default {
  name: 'TechStack'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#message-box {
  height: 200px
}
.form-class {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14pt;
  color: white;
  margin-left: 50px;
  padding: 50px 90px;
  
}
.heading-title {
  text-align: center;
  margin-top: 50px
}
.TechStack {
  margin-top: 50px;
  background-size: 1000px 100% ;
  height: 1000px;
  margin-left: 500px;
}
.separator {
  background-color:#FFF1D6;
  height:125px;
  width:100%;
  margin: 0 auto;
}

h1, h2 {
  font-weight: initial;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 80px;
  font-style: italic;
  color: white
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>


// WEBPACK FOOTER //
// techstack.vue?1f8bcaae